require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-idb-and-the-sustainable-colombia-initiative-sci.json") })
        }
      }, "path---en-us-project-idb-and-the-sustainable-colombia-initiative-sci");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-idb-and-the-sustainable-colombia-initiative-sci!./.cache/json/en-us-project-idb-and-the-sustainable-colombia-initiative-sci.json
// module id = 526
// module chunks = 231608221292675